module.exports = __webpack_public_path__ + "static/media/application-x-sqlite.374x512.7b2b2dc2.png";